import React from 'react';
import { useState, useContext } from "react";
import { ThemeContext } from '../../../App.js';
import SunIcon from 'remixicon-react/SunLineIcon.js';
import "../../style.css";

export default function PrecipType(props) {
    const theme = useContext(ThemeContext);

    const icon = {
        position:'absolute',
        top:5,
        left:5,
        width:16,
        height:16,
        color:'rgb(25, 145, 220)'
    }

    const nameStyle = {
        marginLeft:20
    }

    const valueStyle = {
        display:'inline',
        fontSize:32,
        fontWeight:"bold",
        marginTop:5
    }

    const valueWrapper = {
        position:'relative',
        width:'100%',
        textAlign:'center',
        marginTop:10
    }
    
    const unitStyle = {
        display:'inline',
        fontSize:16,
        marginLeft:5
    }

    function findParam(name) {
        var params;
        console.log("PrecipType:findParam:",name);

        for (var i in props.site.parameters) {
            if(props.site.parameters[i].type == name) {
                return props.site.parameters[i];
            }
        }
        console.log("PrecipType:unknown type:",name);
        return null;
    }

    // Setup
    var tStatus = "Normal";
    // var param;
    var message = props.site.message;
    var value;

    console.log("PrecipType:site:",props.site);
    console.log("PrecipType:reading:",props.reading);

    if(message != null) {
        if("lufft" in message) {
            value = (message.lufft.precip.type).toFixed(2);
        }
        
        props.reading.thresholds.forEach( threshold => {
            if(value > threshold.value) {
                tStatus = threshold.name;
            }
        })

        console.log(tStatus);

    } else {
        console.log("PrecipType:No Message");
        value = 0;
        tStatus = "No Message";
    }

    var type = "Unknown";
    if(message != null) {
        switch(message.lufft.precip.type) {
            case 0:
                type = "No Rain";
                break;

            case 60:
                type = "Rain";
                break;

            case 67:
                type = "Freezing Rain";
                break;

            case 69:
                type = "Sleet";
                break;

            case 70:
                type = "Snow";
                break;
        
            case 90:
                type = "Hail";
                break;
            
            default:
                console.log("Unknown type:",type)
                type = "unknown";
                break;
        }
    }

    return (
        <div className="card precipType">
            <SunIcon id="rainIcon" style={icon}></SunIcon>
            <div className="name" style={nameStyle}>{props.reading.name}</div>
            <div className="wrapper">
                <div className="reading">{type}</div>
            </div>
        </div>
    )
}